var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.021,
    height: 21.99,
    viewBox: "0 0 18.021 21.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-550.355 -2028.509)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 16.054,
    height: 4.19,
    transform: "matrix(0.478, -0.878, 0.878, 0.478, 551.033, 2045.387)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M563.025,2030.386l-2.25-1.216a.811.811,0,0,0-1.106.327l-.979,1.8,3.682,2,.98-1.8A.811.811,0,0,0,563.025,2030.386Z",
    fill: "#dee2e6",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x1: 2.394,
    y2: 4.39,
    transform: "translate(558.145 2032.291)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M551.017,2045.406l.163,4.208,3.52-2.213Z",
    fill: "#dee2e6",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 17.106,
    transform: "translate(551.27 2049.589)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3d441be07bb600ffc7273a2025f175f3.svg";
export { ForwardRef as ReactComponent };